import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HintPanel = ({ hints }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [revealedHints, setRevealedHints] = useState([]);

  const revealHint = (index) => {
    if (!revealedHints?.includes(index)) {
      setRevealedHints([...revealedHints, index]);
    }
  };

  return (
    <div className="bg-card rounded-2xl p-6 shadow-card border border-border">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-left"
      >
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="HelpCircle" size={20} color="var(--color-primary)" />
          Coaching Hints
        </h3>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          color="var(--color-muted-foreground)" 
        />
      </button>
      {isExpanded && (
        <div className="mt-4 space-y-3">
          <p className="text-sm text-muted-foreground">
            Stuck? Reveal hints one at a time to guide your response. Try to use as few as possible!
          </p>
          
          {hints?.map((hint, index) => (
            <div key={index} className="border border-border rounded-lg overflow-hidden">
              {revealedHints?.includes(index) ? (
                <div className="p-4 bg-primary/5">
                  <div className="flex items-start gap-2">
                    <Icon name="Lightbulb" size={16} color="var(--color-accent)" className="flex-shrink-0 mt-1" />
                    <p className="text-sm text-foreground leading-relaxed">{hint}</p>
                  </div>
                </div>
              ) : (
                <Button
                  variant="ghost"
                  onClick={() => revealHint(index)}
                  iconName="Eye"
                  iconPosition="left"
                  fullWidth
                  className="justify-start"
                >
                  Reveal Hint {index + 1}
                </Button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HintPanel;